module.exports = __webpack_public_path__ + "static/media/ehealth_lab_record_banner_mobile.a0c49335.jpg";